import styles from '../LandingPage.module.scss'

export default function LineBreak({
  backgroundColor = 'var(--c-black)',
}: {
  backgroundColor?: string
}) {
  return (
    <div
      className={styles.lineBreakContainer}
      style={{
        backgroundColor,
      }}
    >
      <div className={styles.lineBreak} />
    </div>
  )
}
